import React from "react";
import { useLanguage } from "../i18n/LanguageContext";

export default function Process() {
  const { t } = useLanguage();

  return (
    <section id="process" data-testid="process-section" className="py-20 md:py-24 blueprint-paper text-white">
      <div className="px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-12 mb-12 gap-y-8">
          <div className="col-span-12 md:col-span-4">
            <div className="font-mono-tech text-white/70">
              <span className="inline-block w-2 h-2 bg-[#df4661] mr-3 align-middle" />
              {t.process.eyebrow}
            </div>
          </div>
          <div className="col-span-12 md:col-span-8">
            <h2 data-testid="process-title" className="font-display text-4xl md:text-5xl lg:text-6xl">
              {t.process.title}
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/15">
          {t.process.steps.map((s, i) => (
            <div
              key={s.code}
              data-testid={`process-step-${i}`}
              className="bg-[#1d428a] p-7 md:p-8 group hover:bg-[#df4661] transition-colors duration-500"
            >
              <div className="flex items-baseline gap-3 mb-8">
                <span className="font-mono-tech text-white/70">STEP</span>
                <span className="font-display text-5xl md:text-6xl text-white">{s.code}</span>
              </div>
              <h3 className="font-display text-2xl md:text-3xl mb-3">{s.name}</h3>
              <p className="text-white/80 text-sm leading-relaxed">{s.desc}</p>
              <div className="mt-6 flex items-center justify-between">
                <div className="h-px flex-1 bg-white/25" />
                <span className="font-mono-tech text-white/50 ml-3">→</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
